import React from 'react';
import "./ColorDots.scss";

const ColorDots = ({ priority, background }) => {
    const getPriorityClass = (priority) => {
        switch (priority) {
            case "High":
                return "high";
            case "Medium":
                return "medium";
            case "Low":
                return "low";
            case true:
                return "low";
            case false:
                return "high";
            default:
                return "default";
        }
    };

    // Define priority colors
    const priorityColors = {
        high: '#d93025',
        medium: '#f9ab00',
        low: '#34a853',
        default: '#5f6368'
    };

    const priorityClass = getPriorityClass(priority);
    const backgroundStyle = background ? { 
        backgroundColor: priorityColors[priorityClass],
        padding: '4px 8px',          // From .status-background
        borderRadius: '4px',        // From .status-background
        height: '24px',            // From .status-background
        fontSize: '14px',         // From .status-background
        fontWeight: 500,         // From .status-background
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        lineHeight: 1
    } : {};

    return (
        <div 
            className={`priority-with-dot ${priorityClass}`}
            style={backgroundStyle}
        >
            {!background && (
                <div 
                    className="dot" 
                    style={{ backgroundColor: background ? 'transparent' : priorityColors[priorityClass] }}
                />
            )}
            <span>{priority}</span>
        </div>
    );
};

export default ColorDots;